import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Rnd } from "react-rnd";
import moment from "moment";
import DragIcon from "@material-ui/icons/DragIndicator";
import ActionCreators from "../../store/actions";

const TYPE_CHECK = {
  RESIZE: 2,
  DRAG: 1
};

export class CarsReservedComponent extends PureComponent {
  state = {
    width: 20,
    height: 35,
    x: 0,
    y: 17,

    outCalendar: false,
    color: "#e53935"
  };

  selfRef = React.createRef();
  anchorEl = null;
  timeoutResize = null;

  popoverStorage = {
    operator: null,
    klient: null,
    date_od: null,
    date_do: null
  };

  setPoppoverStorage = newData => {
    this.props.setPopoutValue({
      ...newData
    });

    this.popoverStorage = {
      ...this.popoverStorage,
      ...newData
    };
  };

   round = (date, duration, method) => {
    return moment(Math[method]((+date) / (+duration)) * (+duration));
  };

  checkDate = (weekDaysBoundaries, dragBoundary, id, callBack) => {
    //calculates the date to pass to the request based on the location of the element
    let startDate;
    let endDate;
    let parsedEndDate;
    let parsedStartDate;
    let newIndex = null;
    let divider = this.props.daysCount !== 1 ? 86400000 : 3600000;
    let timeUnit = this.props.daysCount !== 1 ? "day" : "hour";

    weekDaysBoundaries.forEach(boundary => {
      let timeD = boundary.boundaries.width / divider;

      if (boundary.boundaries.left <= dragBoundary.left) {
        newIndex = boundary.index || null;

        const ROUNDING = 15 * 60 * 1000; /*ms*/
        let secondsSinceMidnight =
          (dragBoundary.left - boundary.boundaries.left - 0.2) / timeD;

        startDate = moment(boundary.day)
          .startOf(timeUnit)
          .add(secondsSinceMidnight);
        startDate = moment(Math.ceil((+startDate) / ROUNDING) * ROUNDING);

        parsedStartDate = startDate.format("YYYY-MM-DD HH:mm:ss");

        let secondsSinceStart = dragBoundary.width / timeD;
        endDate = startDate.clone().add(secondsSinceStart);
        endDate = moment(Math.ceil((+endDate) / ROUNDING) * ROUNDING);

        parsedEndDate = endDate.format("YYYY-MM-DD HH:mm:ss");
      }

      if (!!this.state.outCalendar) {
        this.setPoppoverStorage({
          date_od: parsedStartDate
        });

        this.update(
          newIndex,
          moment(parsedStartDate).hour(),
          this.popoverStorage.date_do,
          parsedStartDate
        );
      } else {
        this.setPoppoverStorage({
          date_od:
            startDate &&
              startDate.diff(moment(this.popoverStorage.date_od), "minutes")
              ? parsedStartDate
              : this.popoverStorage.date_od,
          date_do:
            endDate &&
              endDate.diff(moment(this.popoverStorage.date_do), "minutes")
              ? parsedEndDate
              : this.popoverStorage.date_do
        });
      }

      this.setState({ id });

      callBack();
    });
  };

  checkCollision = (dragBoundary, callBack) => {
    //Checks if current drop location is not colliding with another booking
    let scrollY = document.querySelector("#calendar").scrollTop;
    let id;

    this.props.carPositions.forEach(position => {
      if (dragBoundary.y + scrollY >= position.y) {
        id = position.id;
      }
    });

    if (!id) {
      id = this.state.id ? this.state.id : this.props.booking.id_samochod;
    }

    callBack(id);
  };

  check = (e, type, callBack) => {
    //Prepares the variables and boundaries for drag/resize check
    const { parentRef } = this.props;
    let node = null;
    let weekDaysBoundaries = [];
    let dragBoundary;

    node = parentRef.children;
    dragBoundary = this.selfRef.current.getSelfElement().getBoundingClientRect();

    for (let index = 0; index < node.length; index++) {
      const element = node[index];

      for (let index1 = 0; index1 < element.classList.length; index1++) {
        const element1 = element.classList[index1];

        switch (element1) {
          case "header-date":
            {
              weekDaysBoundaries.push({
                boundaries: element.getBoundingClientRect(),
                day: element.getAttribute("data-date") || "",
                index: element.getAttribute("data-elementindex") || ""
              });
            }
            break;
          default:
            break;
        }
      }
    }

    this.checkCollision(dragBoundary, id => {
      this.checkDate(weekDaysBoundaries, dragBoundary, id, callBack);
    });
  };

  update = (
    index,
    startingPosition,
    parsedEndDate,
    parsedStartDate,
    bookingWidth,
  ) => {
    const { cellWidth, daysCount } = this.props;
    let divider = this.props.daysCount !== 1 ? 86400000 : 3600000;

    let width = (cellWidth / divider) * bookingWidth;
    let maxWidth = daysCount * cellWidth;
    let position = startingPosition * (cellWidth / divider);

    if (index == 0) {
      if (width - position >= maxWidth) {
        width = maxWidth - index * Math.floor(cellWidth) - position;
      }
    } else {
      if (
        index * Math.ceil(cellWidth) + Math.ceil(width) >=
        Math.ceil(maxWidth)
      ) {
        width = maxWidth - index * cellWidth - position;
      }
    }

    this.setState({
      width: width
    });
  };

  updateCars() {
    //Prepares the request and sends it.
    const czas_od = moment(this.popoverStorage.date_od).unix();
    const czas_do = moment(this.popoverStorage.date_do).unix();

    console.log('booking', this.props.booking);
    console.log('this.state', this.state);

    let booking = {...this.props.booking,
      token: this.props.token,
      samochod_id: this.state.id,
      czas_od,
      czas_do
    }
    this.props.updateCars(this.props.booking.id_wynajem, booking );
  }

  onDragStop = (e, x) => {
    //Initiating the checks
    const stateX = this.state.x;

    this.check(
      e,
      TYPE_CHECK.DRAG,
      (index, startingPosition, parsedEndDate, parsedStartDate) => {
        let oldY = this.state.y;

        if (
          Math.abs(x.y) - Math.abs(oldY) >= -16 &&
          Math.abs(x.y) - Math.abs(oldY) <= 16
        ) {
          this.setState({ x: x.x });
        } else if (x.y - (oldY + 17) > 0) {
          this.setState({ x: x.x, y: oldY + 70 });
        } else if (x.y - (oldY + 17) < 0) {
          this.setState({ x: x.x, y: oldY - 70 });
        }
      }
    );

    if (stateX.toString().substring(1, 6) !== x.x.toString().substring(1, 6)) {
      this.updateCars();
    }
  };

  onDragStart = e => {
    //disables popover during drag
    e.stopPropagation();
    this.setPoppoverStorage({
      displayPopover: false
    });
  };

  onResize = (e, ref) => {
    let content = this;
    if (this.timeoutResize) {
      clearTimeout(this.timeoutResize)
    }

    this.timeoutResize = setTimeout(() => {
      content.movePopover();
      content.check(e, TYPE_CHECK.RESIZE, () => {
        content.setState({
          width: ref.style.width
        });
      });
    }, 50)
  };

  handlePopoverOpen = event => {
    const { currentTarget } = event;

    if (!this.anchorEl) {
      this.anchorEl = currentTarget;
    }

    this.setPoppoverStorage({
      displayPopover: true,
      anchorEl: currentTarget,
      ...this.popoverStorage
    });
  };

  movePopover = () => {
    this.setPoppoverStorage({
      resetPosition: this.props.resetPosition == 1 ? 2 : 1,
    });
  };

  componentDidMount() {
    ///Calculates the booking position and width based on the data from the API
    const {
      cellWidth,
      bookingWidth,
      daysCount,
      startingPosition,
      index,
      booking,
      periodStartDate,
      periodEndDate
    } = this.props;

    let divider = daysCount !== 1 ? 86400000 : 3600000;
    let width = (cellWidth / divider) * bookingWidth;
    let maxWidth = daysCount !== 1 ? daysCount * cellWidth : 24 * cellWidth;
    let position = (startingPosition * (cellWidth / divider));
    let outCalendar = false;

    if (index == 0) {
      if (width - position >= maxWidth) {
        width = maxWidth - index * Math.floor(cellWidth) - position;
        outCalendar = true;
      }
    } else {
      if (
        index * Math.ceil(cellWidth) + Math.ceil(width) >=
        Math.ceil(maxWidth)
      ) {
        width = maxWidth - index * cellWidth - position;
        outCalendar = true;
      }
    }

    this.setState({
      width: width,
      x: position,
      outCalendar: outCalendar,
      color:
        booking.typ === "Wynajem"
          ? "rgba(149, 117, 205, 0.9)"
          : booking.typ === "Pool"
            ? "rgba(187, 222, 251, 0.7)"
            : "rgba(225, 190, 231, 0.7)"
    });

    if (booking) {

      this.setState({
        isStartDateInPeriod: moment.unix(booking.data_od) > periodStartDate,
        // isEndDateInPeriod: moment.unix(booking.data_do) < periodEndDate,
        isEndDateInPeriod: moment.unix(booking.data_do) != 0,
      });
      this.setPoppoverStorage({
        date_od: moment.unix(booking.data_od).format("YYYY-MM-DD HH:mm:ss"),
        date_do: booking.data_do != 0 ? moment.unix(booking.data_do).format("YYYY-MM-DD HH:mm:ss") : "Brak daty zakończenia",
        operator: booking.operator || "",
        potwierdzony: `${booking.potwierdzony}`,
        klient: booking.klient || "",
        id: booking.id_wynajem
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <Rnd
          resizeHandleStyles={{ right: { width: 24 } }}
          ref={this.selfRef}
          onClick={e => {
            e.stopPropagation();
            this.setPoppoverStorage({
              displayPopover: true,
            })
          }}
          onMouseEnter={event => {
            clearTimeout(this.timer);
            this.handlePopoverOpen(event);
          }}
          onMouseLeave={() => {
            this.props.setPopoutValue({
              displayPopover: false,
            })
          }}
          onDragStop={(e, x) => this.onDragStop(e, x)}
          onDragStart={e => this.onDragStart(e)}
          onResize={(e, direction, ref, delta, position) => this.onResize(e, ref)}
          onResizeStop={() => this.updateCars()}
          id={this.props.ident}
          dragGrid={[1, 70]}
          bounds={".grid-container"}
          size={{ width: this.state.width, height: this.state.height }}
          position={{ x: this.state.x, y: this.state.y }}
          className={"car-reserved"}
          style={{
            display: "flex",
            flexWrap: "no-wrap",
            borderTopLeftRadius: this.state.isStartDateInPeriod ? "10px" : "0",
            borderBottomLeftRadius: this.state.isStartDateInPeriod ? "10px" : "0",
            borderTopRightRadius: this.state.isEndDateInPeriod ? "10px" : "0",
            borderBottomRightRadius: this.state.isEndDateInPeriod ? "10px" : "0",
            position: "absolute",
            backgroundColor: this.state.color,
            overflow: "hidden",
            textOverflow: "ellipsis",
            alignItems: "center",
            whiteSpace: "no-wrap"
          }}
          enableResizing={{
            top: false,
            right: true,
            bottom: false,
            left: false,
            topRight: false,
            bottomRight: false,
            bottomLeft: false,
            topLeft: false
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%"
            }}
          >
            <span />
            <div
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }}
            >
              {this.props.children}
            </div>
            {
              this.state.isEndDateInPeriod ?
                <DragIcon /> : <span />
            }
          </div>
        </Rnd>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    resetPosition: state.popoutReducer.resetPosition,
    token: state.authReducer.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(ActionCreators, dispatch),
    setPopoutValue: value =>
      dispatch({ type: "SET_POPOUT_DATA", value: value }),
    loader: value => dispatch({ type: "REQUEST_LOADER", value: value })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CarsReservedComponent);
